import { battery } from '@/Components/Common/deviceUtils.jsx';
import { HSText } from '@/Components/Common/HSText';
import CooktopIcon from '@/Components/Common/Icons/cook-top-sensor.svg';
import DoorSensorIcon from '@/Components/Common/Icons/door-sensor-icon.svg';
import IncontinenceSensorIcon from '@/Components/Common/Icons/incontinence-icon.svg';
import OccupancySensorIcon from '@/Components/Common/Icons/occupancy-sensor.svg';
import RadarSensorIcon from '@/Components/Common/Icons/radar-sensor.svg';
import SmartPlugIcon from '@/Components/Common/Icons/smart-plug.svg';
import FlushSensorIcon from '@/Components/Common/Icons/toilet-flush-sensor.svg';
import { AccuweatherIcon } from '@/Components/Environmental/AccuweatherIcon';
import { SENSORS, SENSOR_VARIANTS } from '@/constants/device';
import { kebabCase } from 'lodash';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  &.outdoor-temperature-humidity-sensor {
    position: relative;
    left: 77px;
  }
`;

const SensorIcon = ({
  deviceType,
  variant,
  sensorStatus,
  batteryStatus,
  batteryLevel,
  connectionless = false,
}) => {
  switch (deviceType) {
    case SENSORS.SMART_HOME.DOOR_WINDOW_SENSOR: {
      return (
        <div className={`door-sensor-icon-container ${connectionless ? 'connectionless' : ''}`}>
          <DoorSensorIcon className={`sensor-status ${sensorStatus} ${batteryStatus}`} />
        </div>
      );
    }
    case SENSORS.SMART_HOME.OCCUPANCY_SENSOR: {
      const IconComponent =
        variant === SENSOR_VARIANTS.INCONTINENCE ? IncontinenceSensorIcon : OccupancySensorIcon;
      return (
        <div className={`occupancy-sensor-icon ${connectionless ? 'connectionless' : ''}`}>
          <IconComponent className={`sensor-status ${sensorStatus} ${batteryStatus}`} />
        </div>
      );
    }
    case SENSORS.SMART_HOME.RADAR_SENSOR: {
      return (
        <div
          className={`sensor-icon-container radar-sensor-icon ${sensorStatus || ''} ${connectionless ? 'connectionless' : ''}`}
        >
          <RadarSensorIcon className={`sensor-status ${sensorStatus} ${batteryStatus}`} />
        </div>
      );
    }
    case SENSORS.SMART_HOME.TOILET_FLUSH_SENSOR: {
      return (
        <div
          className={`sensor-icon-container flush-sensor-icon ${connectionless ? 'connectionless' : ''}`}
        >
          <FlushSensorIcon className={`sensor-status ${sensorStatus} ${batteryStatus}`} />
        </div>
      );
    }
    case SENSORS.SMART_HOME.SMART_PLUG: {
      return (
        <div className={`sensor-icon-container ${connectionless ? 'connectionless' : ''}`}>
          <SmartPlugIcon className={`sensor-status ${sensorStatus}`} />
        </div>
      );
    }
    case SENSORS.SMART_HOME.COOKTOP_SENSOR: {
      return (
        <div className={`sensor-icon-container ${connectionless ? 'connectionless' : ''}`}>
          <CooktopIcon className={`sensor-status ${sensorStatus}`} />
        </div>
      );
    }
    case SENSORS.SMART_HOME.OUTDOOR_TEMPERATURE_HUMIDITY_SENSOR: {
      return null;
    }
    case SENSORS.SMART_HOME.TEMPERATURE_HUMIDITY_SENSOR:
    case SENSORS.SMART_HOME.ENVIRONMENTAL_SENSOR:
    default: {
      return (
        <div className={`sensor-icon-container ${connectionless ? 'connectionless' : ''}`}>
          {battery(batteryLevel, sensorStatus, connectionless)}
        </div>
      );
    }
  }
};
SensorIcon.propTypes = {
  deviceType: PropTypes.string,
  variant: PropTypes.string,
  sensorStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  batteryStatus: PropTypes.string,
  batteryLevel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  connectionless: PropTypes.bool,
};

export const SensorDetailsTile = ({
  location,
  modelname,
  sensorStatus,
  batteryStatus,
  deviceType,
  variant,
  batteryLevel,
  connectionless = false,
  zoneName,
}) => {
  const displayLocation = location && location !== '-' ? location : zoneName;
  return (
    <Wrapper className={`sensor-info ${kebabCase(deviceType)}`}>
      <SensorIcon
        deviceType={deviceType}
        variant={variant}
        sensorStatus={sensorStatus}
        batteryStatus={batteryStatus}
        batteryLevel={batteryLevel}
        connectionless={connectionless}
      />
      <div className="sensor-name">
        <div className="sensor-name-title">
          <HSText className="title-blue location">{displayLocation}</HSText>
        </div>
        <HSText className="grey-value model-name">{modelname}</HSText>
        {deviceType === SENSORS.SMART_HOME.OUTDOOR_TEMPERATURE_HUMIDITY_SENSOR && (
          <div className="accuweather-container">
            <AccuweatherIcon />
          </div>
        )}
      </div>
    </Wrapper>
  );
};
SensorDetailsTile.propTypes = {
  location: PropTypes.string,
  modelname: PropTypes.string,
  sensorStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  batteryStatus: PropTypes.string,
  deviceType: PropTypes.string,
  variant: PropTypes.string,
  batteryLevel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  connectionless: PropTypes.bool,
  zoneName: PropTypes.string,
};
